import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Member } from '../types/index 2';
import {
  User,
  Phone,
  MessageCircle,
  UserCheck,
  Clipboard,
  Target,
  Zap,
  FileText,
  ChevronDown,
  TrendingUp,
  AlertTriangle,
  CheckCircle,
  Sparkles,
  Database,
  Users,
  Calendar,
  ThumbsUp,
  ThumbsDown,
  Edit,
  FileCheck,
  Clock,
  Shield,
  PhoneOff,
  Timer,
  Download,
  File as FileIcon,
  X
} from 'lucide-react';
import { Badge, PriorityBadge, ConfidenceBadge, EffortBadge } from '../components/ui/Badge';
import { ProgressBar } from '../components/ui/ProgressBar';
import { Pill, TimeframePill } from '../components/ui/Pill';
import { Card } from '../components/ui/Card';
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

interface AIInsight {
  id: string;
  insight_type: string;
  severity: string;
  title: string;
  description: string;
  confidence_score: number;
  data_sources: string[];
}

interface Intervention {
  id: string;
  category: string;
  title: string;
  description: string;
  effort_level: 'low' | 'medium' | 'high';
  confidence_score: number;
  impact_description: string;
  evidence_citation: string;
  status: string;
}

interface CareTeamMember {
  id: string;
  name: string;
  role: string;
  title: string;
  responsibilities: string;
}

interface CarePlan {
  id: string;
  plan_type: string;
  confidence_score: number;
  status: string;
  effective_date: string;
  review_date: string;
  problems_count: number;
}

interface CarePlanGoal {
  id: string;
  problem_code: string;
  problem_name: string;
  goal_text: string;
  timeframe_days: number;
  priority: string;
  completed: boolean;
}

interface DataSource {
  source_name: string;
  record_count: number;
}

const MOCK_API_RESPONSE = {
    "output": {
        "transcription": "Hello? We are calling today to do a PREPARE assessment. Am I speaking with Abel Smith? Yeah, this is Abel. To protect your privacy, could you please confirm your date of birth? It's January 1st, 1998. Thank you for confirming. I hope you're having a good day. I'm calling to do a brief health conversation called a PREPARE assessment. It helps us understand how life circumstances affect your health. Everything we discuss stays confidential. You can skip any question or stop at any time. Would you like to proceed? I mean, why should I take this assessment? It just helps us get a better picture of your well-being so we can provide the best care. Is that okay to continue? Who do you represent again? I'm calling from Molina Healthcare. Shall we move on to the questions? That's fine. Go ahead. First, I have a couple of background questions. Do you consider yourself Hispanic or Latino? I am not Hispanic or Latino. Thank you. What race or ethnic background do you identify with? You can tell me in your own words, or I can list options. Yeah, go ahead and list options. Some common options are white, black, or African American, Asian, American Indian, or Alaska Native, or Native Hawaiian or Pacific Islander. Are there any of those or something else? Asian. Got it. Have you ever served in the U.S. military? No, not really. Now I'd like to ask a few questions about your living situation, including yourself, how many people live in your household? Like two people. Thank you. Tell me about your housing right now. Is it stable or are you staying with others and temporary housing or something else? It's stable, but I am staying with a few other folks. I hear you. Thank you for sharing. Next, I have a few questions about work, education, and income. What's the highest level of education you've completed? Just high school. Are you currently working for pay? If not, are you looking for work or unable to work? I am looking for work currently. I haven't found anything recently. I understand. What type of health insurance do you have right now? I don't know, to be honest with you. No problem. We can skip that one. This next one can be personal. A range is fine. What is your household's approximate yearly income? It's like $15,000, but you know, it depends on really work. An estimate is totally fine. Thank you. Now a few questions about social support and stress. How often do you see or talk with people you care about? I mean, I see them often, you know, people from my house. That sounds good. When I say stress, I mean feeling tense, worried, anxious, or having trouble sleeping. Would you say you feel stressed almost all the time, often, sometimes, rarely, or never? I'd say a little bit of stress, yeah. Maybe a bit often. I'm sorry you're feeling that. Thank you for telling me. That takes strength. Finally, I have a question about safety. Do you feel physically and emotionally safe where you currently live? I'm okay for now. That completes our prepare assessment, Abel. Thank you so much for sharing this important information. Is there anything else you'd like me to know? That's all. Take care of yourself and have a wonderful rest of your day. Goodbye. Goodbye.",
        "contact_details": {
            "name": "Abel Smith",
            "date_of_birth": "1998-01-01",
            "phone": null,
            "email": null,
            "address": null
        },
        "question_output": [
            {
                "question_id": "1",
                "question": "Assessment Method",
                "type": "dropdown",
                "answer": "Telephonic",
                "options": [
                    "Digitally completed",
                    "In-Person",
                    "IVR",
                    "Mailed",
                    "Member Portal",
                    "Molina App",
                    "Sales/Broker",
                    "Telephonic",
                    "Televisit",
                    "Welcome Kits",
                    "Other"
                ],
                "nested_questions": []
            },
            {
                "question_id": "4",
                "question": "Asssessment Type",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Initial",
                    "Annual / Reassessment",
                    "Referral",
                    "Change in health status"
                ],
                "nested_questions": []
            },
            {
                "question_id": "7",
                "question": "Assessment Date",
                "type": "date",
                "answer": "2026-02-03",
                "nested_questions": []
            },
            {
                "question_id": "8",
                "question": "Member First Name",
                "type": "textbox",
                "answer": "Abel",
                "nested_questions": []
            },
            {
                "question_id": "9",
                "question": "Member Last Name",
                "type": "textbox",
                "answer": "Smith",
                "nested_questions": []
            },
            {
                "question_id": "10",
                "question": "Member Healthcare ID",
                "type": "textbox",
                "answer": "Not mentioned in the transcript",
                "nested_questions": []
            },
            {
                "question_id": "11",
                "question": "Member's Date of Birth",
                "type": "date",
                "answer": "1998-01-01",
                "nested_questions": []
            },
            {
                "question_id": "12",
                "question": "Address",
                "type": "textbox",
                "answer": "Not mentioned in the transcript",
                "nested_questions": []
            },
            {
                "question_id": "13",
                "question": "City",
                "type": "textbox",
                "answer": "Not mentioned in the transcript",
                "nested_questions": []
            },
            {
                "question_id": "14",
                "question": "State",
                "type": "textbox",
                "answer": "Not mentioned in the transcript",
                "nested_questions": []
            },
            {
                "question_id": "15",
                "question": "Zip Code",
                "type": "textbox",
                "answer": "Not mentioned in the transcript",
                "nested_questions": []
            },
            {
                "question_id": "16",
                "question": "Contact Phone",
                "type": "textbox",
                "answer": "Not mentioned in the transcript",
                "nested_questions": []
            },
            {
                "question_id": "17",
                "question": "Cell Phone",
                "type": "textbox",
                "answer": "Not mentioned in the transcript",
                "nested_questions": []
            },
            {
                "question_id": "20",
                "question": "Phone for Person Completing the Survey",
                "type": "textbox",
                "answer": "Not mentioned in the transcript",
                "nested_questions": []
            },
            {
                "question_id": "18",
                "question": "Who is completing this form?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Member",
                    "Other"
                ],
                "nested_questions": []
            },
            {
                "question_id": "21",
                "question": "Are you of Hispanic, Latino or Spanish origin?",
                "type": "checkbox",
                "answer": "A. No, not of Hispanic, Latino or Spanish origin",
                "options": [
                    "A. No, not of Hispanic, Latino or Spanish origin",
                    "B. Yes, Mexican, Mexican American, Chicano",
                    "C. Yes, Puerto Rican",
                    "D. Yes, Cuban",
                    "E. Yes, another Hispanic, Latino or Spanish origin  Print origin, for example, Argentinean, Colombian, Dominican, Nicaraguan, Salvadoran, Spaniard, and so on",
                    "F. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "23",
                "question": "Please select the racial category or categories which you most closely identify with:",
                "type": "checkbox",
                "answer": "B. Asian",
                "options": [
                    "A. American Indian or Alaska Native",
                    "B. Asian",
                    "C. Black or African American ",
                    "D. Native Hawaiian or another Pacific islander",
                    "E. Hispanic or Latino",
                    "F. White",
                    "G. Multiracial",
                    "H. Something else",
                    "I. I choose not to answer",
                    "J. Middle Eastern or North African"
                ],
                "nested_questions": []
            },
            {
                "question_id": "26",
                "question": "What is your preferred spoken language?",
                "type": "checkbox",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Arabic ",
                    "B. Chinese",
                    "C. Creole ",
                    "D. English ",
                    "E. French   ",
                    "F. Mandarin ",
                    "G. Russian",
                    "H. Somali ",
                    "I. Spanish",
                    "J. Tagalog",
                    "K. Vietnamese",
                    "L. Something else"
                ],
                "nested_questions": []
            },
            {
                "question_id": "249",
                "question": "What is your preferred written language?",
                "type": "checkbox",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Arabic ",
                    "B. Chinese ",
                    "C. Creole ",
                    "D. English ",
                    "E. French",
                    "F. Mandarin",
                    "G. Russian",
                    "H. Somali",
                    "I. Spanish",
                    "J. Tagalog",
                    "K. Vietnamese",
                    "L. Something else"
                ],
                "nested_questions": []
            },
            {
                "question_id": "248",
                "question": "Do you need any of these services?",
                "type": "checkbox",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Audio recordings",
                    "B. Braille materials",
                    "C. Large print materials",
                    "D. If you need a service not listed, please add it here:",
                    "E. None"
                ],
                "nested_questions": []
            },
            {
                "question_id": "236",
                "question": "Have you ever served in the United States military/armed forces?",
                "type": "dropdown",
                "answer": "No",
                "options": [
                    "Yes",
                    "No",
                    "I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "28",
                "question": "What is your sexual orientation?  (Please choose the option that best describes you.)",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Lesbian or gay or homosexual",
                    "B. Straight or heterosexual",
                    "C. Bisexual",
                    "D. Something else, please describe",
                    "E. I don't know",
                    "F. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "30",
                "question": "What is your highest level of school completed?",
                "type": "dropdown",
                "answer": "B. High school diploma/GED",
                "options": [
                    "A. Less than a high school diploma",
                    "B. High school diploma/GED",
                    "C. Vocational/trade school ",
                    "D. Some college",
                    "E. College degree (associates or bachelor's)",
                    "F. Graduate degree",
                    "G. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "31",
                "question": "What is your living situation?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Live in a home that I own",
                    "B. Live in a home/apartment that I rent",
                    "C. Live with family member",
                    "D. Live in a shelter",
                    "E. Live in foster care",
                    "F. Live in a group home ",
                    "G. Live in an assisted living facility",
                    "H. Nursing home",
                    "I. Homeless/unsheltered",
                    "J. Something else",
                    "K. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "33",
                "question": "Do you have any preferences or considerations we should be aware of?  Please select all that apply.",
                "type": "checkbox",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Cultural preferences",
                    "B. Religion/Spiritual needs or preferences",
                    "C. Hearing difficulty",
                    "D. Vision problems",
                    "E. None",
                    "F. Something else"
                ],
                "nested_questions": []
            },
            {
                "question_id": "38",
                "question": "Have you been diagnosed with or are currently being treated for any of the following behavioral health conditions? Please select all that apply. ",
                "type": "checkbox",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. I have never been diagnosed or treated for any behavioral health conditions",
                    "B. ADHD (attention deficit hyperactivity disorder)",
                    "C. Anxiety ",
                    "D. Autism",
                    "E. Bipolar Disorder",
                    "F. Depression ",
                    "G. Psychotic disorder (Schizophrenia) ",
                    "H. Substance use disorder",
                    "I. Other:"
                ],
                "nested_questions": []
            },
            {
                "question_id": "40",
                "question": "Do you use illegal substances or prescription medications not prescribed for you (e.g., cocaine, heroin, opioids)?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes",
                    "B. No",
                    "C. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "41",
                "question": "In the past year, have you consumed alcohol daily, needed to drink in the morning, or have people annoyed you by criticizing your drinking?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes",
                    "B. No",
                    "C. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "43",
                "question": "Do you have a main health concern right now? ",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes,",
                    "B. No",
                    "C. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "101",
                "question": "I have never been diagnosed or treated for any heath conditions",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "189",
                "question": "B. Asthma",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "190",
                "question": "C. Cancer (actively being treated)",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "191",
                "question": "D. Cognitive (memory concerns, such as dementia) and/or development limitations",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "192",
                "question": "E. COPD (Chronic obstructive pulmonary disease)",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "193",
                "question": "F. Diabetes",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "194",
                "question": "G. Chronic Kidney Disease / Dialysis",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "195",
                "question": "H. Heart failure",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "196",
                "question": "I. Stroke",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "197",
                "question": "J. HIV/AIDS",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "198",
                "question": "K. Liver disease, such as cirrhosis or ascites",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "199",
                "question": "L. High blood pressure",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "200",
                "question": "M. Neurologic disorder (such as epilepsy, multiple sclerosis)",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "201",
                "question": "N. Blood disorders (this covers those with sickle cell, or  clotting deficiencies)",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "202",
                "question": "O. Other:",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "47",
                "question": "Do you worry about your memory or have you been told by friends or family that they are worried about your memory?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes",
                    "B. No",
                    "C. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "48",
                "question": "Do you have pain?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes",
                    "B. No",
                    "C. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "51",
                "question": "In the past 6 months, how often have you visited the emergency room or stayed overnight in the hospital? ",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. One time or not at all",
                    "B. 2 to 5 times",
                    "C. More than 6 times",
                    "D. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "106",
                "question": "Are you taking your medications as prescribed? Let me know if you are not prescribed medications.",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes",
                    "B. No",
                    "C. I am not prescribed medications",
                    "D. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "53",
                "question": "Have you fallen in the last 6 months that resulted in medical care?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes",
                    "B. No",
                    "C. Unsure"
                ],
                "nested_questions": []
            },
            {
                "question_id": "156",
                "question": "Are you currently pregnant?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes",
                    "B. No",
                    "C. Unsure",
                    "D. I choose not to answer",
                    "E. N/A"
                ],
                "nested_questions": []
            },
            {
                "question_id": "57",
                "question": "Are you currently receiving any long-term services and supports, such as personal attendant services, day activity services or emergency response services?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes",
                    "B. No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "214",
                "question": "Bathing / showering",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "215",
                "question": "Hygiene",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "216",
                "question": "Dressing",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "217",
                "question": "Walking / mobility",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "218",
                "question": "Toileting",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "219",
                "question": "Eating",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "220",
                "question": "Grocery shopping",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "221",
                "question": "Meal preparation",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "222",
                "question": "Housework / cleaning",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "223",
                "question": "Managing finances",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "224",
                "question": "Climbing stairs",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "174",
                "question": "Decline to Answer",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            
            {
                "question_id": "71",
                "question": "In the past year, have you or any family members you live with been unable to get food when it was really needed?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes",
                    "B. No",
                    "C. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "70",
                "question": "What is your housing situation today?",
                "type": "radio",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. I do not have housing (I am staying with others, in a hotel, in a shelter, living outside on the street, on a beach, in a car, abandoned building, bus or train station, or in a park)",
                    "B. I have housing today, but I am worried about losing housing in the future",
                    "C. I have housing",
                    "D. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "72",
                "question": "Has lack of transportation kept you from medical appointments, meetings, work, or from getting things needed for daily living?  Check all that apply.",
                "type": "checkbox",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Yes, it has kept me from medical appointments or getting medications",
                    "B. Yes, it has kept me from non-medical meetings, appointments, work, or getting things I need",
                    "C. No",
                    "D. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "73",
                "question": "Do you feel physically and emotionally safe where you current live?",
                "type": "dropdown",
                "answer": "I'm okay for now",
                "options": [
                    "A. Yes",
                    "B. No",
                    "C. Unsure",
                    "D. I choose not to answer"
                ],
                "nested_questions": []
            },
            {
                "question_id": "229",
                "question": "Do you use a walker, cane or wheelchair?",
                "type": "dropdown",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "Yes",
                    "No"
                ],
                "nested_questions": []
            },
            {
                "question_id": "74",
                "question": "In the past year, have you or any family members you live with been unable to get any of the following when it was really needed?  Check all that apply.",
                "type": "checkbox",
                "answer": "Not mentioned in the transcript",
                "options": [
                    "A. Clothing ",
                    "B. Utilities",
                    "C. Child care",
                    "D. Medicine or any healthcare (medical, dental, mental health, vision)",
                    "E. Phone",
                    "F. Money",
                    "G. Training/employment",
                    "H. Other",
                    "I. I choose not to answer",
                    "J. None"
                ],
                "nested_questions": []
            }
        ]
    },
    "usage": {
        "input_tokens": 90669,
        "output_tokens": 4499
    },
    "cost": 0.21733
};

export default function Member360Enhanced() {
  const { memberId } = useParams<{ memberId: string }>();
  const navigate = useNavigate();
  const [member, setMember] = useState<Member | null>(null);
  const [activeTab, setActiveTab] = useState<'assessment' | 'careplan' | 'interventions' | 'documentation'>('assessment');
  const [aiInsights, setAiInsights] = useState<AIInsight[]>([]);
  const [interventions, setInterventions] = useState<Intervention[]>([]);
  const [careTeam, setCareTeam] = useState<CareTeamMember[]>([]);
  const [carePlan, setCarePlan] = useState<CarePlan | null>(null);
  const [carePlanGoals, setCarePlanGoals] = useState<CarePlanGoal[]>([]);
  const [dataSources, setDataSources] = useState<DataSource[]>([]);
  const [loading, setLoading] = useState(true);
  
  // Call Feature State
  const [isCalling, setIsCalling] = useState(false);
  const [callDuration, setCallDuration] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const [callData, setCallData] = useState<any | null>(null);
  const [showCallModal, setShowCallModal] = useState(false);

  useEffect(() => {
    if (memberId) {
      fetchMemberData(memberId);
    }
  }, [memberId]);

  useEffect(() => {
    let interval: any;
    if (isCalling) {
      interval = setInterval(() => {
        setCallDuration((prev) => prev + 1);
      }, 1000);
    } else {
      setCallDuration(0);
    }
    return () => clearInterval(interval);
  }, [isCalling]);

  const fetchMemberData = async (memberIdParam: string) => {
    try {
      setLoading(true);
      const { data: memberData, error: memberError } = await supabase
        .from('members')
        .select('*')
        .eq('member_id', memberIdParam)
        .maybeSingle();

      if (memberError) throw memberError;
      setMember(memberData);

      if (memberData) {
        const [insightsRes, interventionsRes, teamRes, planRes, goalsRes, sourcesRes] =
          await Promise.all([
            supabase
              .from('ai_insights')
              .select('*')
              .eq('member_id', memberData.id)
              .limit(3),
            supabase
              .from('interventions')
              .select('*')
              .eq('member_id', memberData.id)
              .eq('status', 'pending')
              .order('confidence_score', { ascending: false }),
            supabase
              .from('care_team_members')
              .select('*')
              .eq('member_id', memberData.id)
              .eq('active', true),
            supabase
              .from('care_plans')
              .select('*')
              .eq('member_id', memberData.id)
              .eq('status', 'active')
              .maybeSingle(),
            supabase
              .from('care_plan_goals')
              .select('*, care_plans!inner(member_id)')
              .eq('care_plans.member_id', memberData.id)
              .limit(10),
            supabase.from('data_sources').select('source_name, record_count'),
          ]);

        if (insightsRes.data) setAiInsights(insightsRes.data);
        if (interventionsRes.data) setInterventions(interventionsRes.data);
        if (teamRes.data) setCareTeam(teamRes.data);
        if (planRes.data) setCarePlan(planRes.data);
        if (goalsRes.data) setCarePlanGoals(goalsRes.data);
        if (sourcesRes.data) setDataSources(sourcesRes.data);
      }
    } catch (error) {
      console.error('Error fetching member data:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };

  const getRiskScoreColor = (score: number) => {
    if (score >= 4) return 'text-red-600';
    if (score >= 3) return 'text-orange-600';
    if (score >= 2) return 'text-amber-600';
    return 'text-green-600';
  };

  const getRiskPriority = (score: number | undefined | null): 'high' | 'medium' | 'low' | 'critical' => {
    const safeScore = score ?? 0;
    if (safeScore >= 4.5) return 'critical';
    if (safeScore >= 4) return 'high';
    if (safeScore >= 3) return 'medium';
    return 'low';
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleStartCall = () => {
    setIsCalling(true);
    setShowCallModal(true);
    setCallData(null);
  };

  const handleEndCall = () => {
    setIsCalling(false);
    setIsProcessing(true);
    // Simulate API call
    setTimeout(() => {
      setCallData(MOCK_API_RESPONSE);
      setIsProcessing(false);
    }, 2000);
  };

  const handleCloseModal = () => {
    setShowCallModal(false);
    setCallData(null);
    setIsCalling(false);
    setIsProcessing(false);
  };

  const handleDownloadPDF = async () => {
    if (!callData) return;
    try {
      const pdfDoc = await PDFDocument.create();
      let page = pdfDoc.addPage();
      const { height, width } = page.getSize();
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      const margin = 50;
      const maxWidth = width - margin * 2;

      const wrapText = (text: string, size: number) => {
        const words = String(text).split(' ');
        const lines: string[] = [];
        let current = '';
        words.forEach((w) => {
          const test = current ? current + ' ' + w : w;
          if (font.widthOfTextAtSize(test, size) > maxWidth) {
            if (current) lines.push(current);
            current = w;
          } else {
            current = test;
          }
        });
        if (current) lines.push(current);
        return lines;
      };

      const drawHeader = () => {
        let y = height - margin;
        page.drawText('New Outgoing Contact Form', { x: margin, y, size: 22, font: boldFont });
        y -= 28;
        const contact = callData.output?.contact_details;
        if (contact) {
          page.drawText(`Name: ${contact.name}`, { x: margin, y, size: 12, font });
          y -= 18;
          page.drawText(`Date of Birth: ${contact.date_of_birth}`, { x: margin, y, size: 12, font });
          y -= 24;
        }
        page.drawLine({
          start: { x: margin, y },
          end: { x: width - margin, y },
          thickness: 1,
        });
        return y - 20;
      };

      let y = drawHeader();

      const questions = callData.output?.question_output || [];

      questions.forEach((item: any, idx: number) => {
          if (y < margin + 80) {
            page = pdfDoc.addPage();
            const size = page.getSize();
            y = size.height - margin;
            page.drawText('New Outgoing Contact Form', { x: margin, y, size: 22, font: boldFont });
            y -= 28;
          }
          const qPrefix = `Q${idx + 1}. `;
          const qLines = wrapText(qPrefix + (item.question ?? item.label), 12);
          qLines.forEach((line) => {
            page.drawText(line, { x: margin, y, size: 12, font: boldFont });
            y -= 16;
          });
          if (item.type === 'radio' || item.type === 'checkbox') {
            const selected = Array.isArray(item.answer) ? new Set(item.answer) : new Set([item.answer]);
            (item.options || []).forEach((opt: string) => {
              const mark = selected.has(opt) ? '[x]' : '[ ]';
              const line = `${mark} ${opt}`;
              const lines = wrapText(line, 11);
              lines.forEach((l) => {
                page.drawText(l, { x: margin + 12, y, size: 11, font });
                y -= 14;
              });
            });
          } else {
            const aLines = wrapText(String(item.answer || 'N/A'), 11);
            aLines.forEach((line) => {
              page.drawText(line, { x: margin + 12, y, size: 11, font });
              y -= 14;
            });
          }
          y -= 10;
          page.drawLine({
            start: { x: margin, y },
            end: { x: width - margin, y },
            thickness: 0.5,
          });
          y -= 12;
      });

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'new-outgoing-contact-form.pdf';
      link.click();
    } catch (e) {
      console.error("PDF Generation Error", e);
    }
  };

  const handleDownloadDOCX = () => {
    const questions = callData?.output?.question_output || [];
    const contact = callData?.output?.contact_details;
    
    const content = `
      <html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
      <head>
        <meta charset='utf-8'>
        <title>New Outgoing Contact Form</title>
        <style>
          body { font-family: "Times New Roman", serif; margin: 1in; color: #111; }
          h1 { font-size: 24px; margin: 0 0 12px 0; }
          .sub { color: #666; font-size: 12px; margin-bottom: 18px; }
          hr { border: 0; border-top: 1px solid #ddd; margin: 16px 0; }
          .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; margin-bottom: 18px; }
          .label { font-size: 11px; color: #666; margin: 0; }
          .value { font-size: 13px; margin: 2px 0 0 0; }
          .q { font-size: 13px; font-weight: 700; margin: 14px 0 6px 0; }
          .opt { font-size: 12px; margin: 4px 0; }
          .sep { border-top: 1px solid #eee; margin: 12px 0; }
          .two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        </style>
      </head>
      <body>
        <h1>New Outgoing Contact Form</h1>
        <div class="sub">Generated from call summary</div>
        ${contact ? `
          <div class="grid">
            <div>
              <p class="label">Name</p>
              <p class="value">${contact.name}</p>
            </div>
            <div>
              <p class="label">Date of Birth</p>
              <p class="value">${contact.date_of_birth}</p>
            </div>
          </div>
          <hr/>
        ` : ''}
        <div class="two-col">
        ${questions.map((item: any, i: number) => {
          const isChoice = item.type === 'radio' || item.type === 'checkbox';
          const selected = Array.isArray(item.answer) ? new Set(item.answer) : new Set([item.answer]);
          const opts = (item.options || []).map((opt: string) => {
            const mark = selected.has(opt) ? '☑' : '☐';
            return `<div class="opt">${mark} ${opt}</div>`;
          }).join('');
          const ans = !isChoice ? `<div class="opt">${String(item.answer || 'N/A')}</div>` : '';
          return `
            <div>
              <div class="q">Q${i + 1}. ${(item.question ?? item.label)}${item.optional ? ' <span style=\"color:#999;font-weight:400;\">(Optional)</span>' : ''}</div>
              ${isChoice ? opts : ans}
              <div class="sep"></div>
            </div>
          `;
        }).join('')}
        </div>
      </body>
      </html>
    `;
    const blob = new Blob([content], { type: 'application/msword' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'new-outgoing-contact-form.doc';
    link.click();
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading member data...</p>
        </div>
      </div>
    );
  }

  if (!member) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600">Member not found</p>
      </div>
    );
  }

  const assessmentCompletion = 68;
  const nextContactDate = '2024-12-16';

  return (
    <div className="min-h-screen bg-gray-50 relative">
      {/* Call Modal / Overlay */}
      {showCallModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
            <div className="py-3 px-5 border-b border-gray-200 flex justify-between items-center bg-gray-50 rounded-t-xl">
              <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                {isCalling ? (
                   <>
                     <Phone className="w-5 h-5 text-green-600 animate-pulse" />
                     Call in Progress
                   </>
                ) : isProcessing ? (
                   <>
                     <Sparkles className="w-5 h-5 text-purple-600 animate-spin" />
                     Processing Call Data...
                   </>
                ) : (
                   <>
                   <div className='flex gap-4 items-center'>
                      <Clipboard className="w-6 h-6 text-purple-600" />
                      <div className='flex flex-col gap-0'>
                        <h1 className="text-xl font-bold text-gray-900">Contract Form</h1>
                        <p className="text-gray-500 text-sm">Generated from call summary</p>
                      </div>
                    </div>
                   </>
                )}
              </h2>
              <button onClick={handleCloseModal} className="text-gray-500 hover:text-gray-700">
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="p-2">
              {isCalling && (
                <div className="text-center py-12">
                  <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
                    <Phone className="w-12 h-12 text-green-600" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {member.first_name} {member.last_name}
                  </h3>
                  <div className="flex items-center justify-center gap-2 text-gray-600 mb-8">
                    <Timer className="w-5 h-5" />
                    <span className="text-xl font-mono">{formatTime(callDuration)}</span>
                  </div>
                  <button
                    onClick={handleEndCall}
                    className="px-4 py-1.5 text-lg mx-auto !text-red-600 !border-red-600 hover:!bg-red-700 hover:!text-white rounded-full transition btn-secondary"
                  >
                    <PhoneOff className="w-5 h-5" />
                    End Call
                  </button>
                </div>
              )}

              {isProcessing && (
                <div className="text-center py-16">
                   <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-purple-600 mx-auto mb-6"></div>
                   <h3 className="text-lg font-semibold text-gray-900">Generating Form...</h3>
                   <p className="text-gray-500 mt-2">AI is analyzing the conversation and preparing the structured form.</p>
                </div>
              )}

              {callData && !isCalling && !isProcessing && (
                <div className="space-y-6 max-h-[72vh] overflow-y-auto">
                  <div className='preview-form-content px-4 pb-4'>
                    <div className="flex items-center justify-between pb-2 border-b border-solid border-gray-200">
                      <p className="text-sm text-gray-600">
                        Based on the call, the following information has been pre-filled. Please review.
                      </p>
                      <div className="flex gap-2">
                        <button onClick={handleDownloadPDF} className="px-3 py-1.5 !mt-0 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 flex items-center gap-2">
                          <FileIcon className="w-4 h-4 text-red-500" />
                          PDF
                        </button>
                        <button onClick={handleDownloadDOCX} className="px-3 py-1.5 !mt-0 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 flex items-center gap-2">
                          <FileIcon className="w-4 h-4 text-blue-500" />
                          DOCX
                        </button>
                      </div>
                    </div>

                    <div className="">
                      {/* <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-900">Contract Form</h1>
                        <p className="text-gray-500 text-sm">Generated from call summary</p>
                        <hr className="mt-4 border-gray-200" />
                      </div> */}

                      {callData.output?.contact_details && (
                        <div className="flex gap-4 justify-between py-4 border-b border-solid border-gray-200 mb-6">
                          <div className='flex items-center gap-2'>
                            <p className="text-sm text-gray-900 font-medium">Name: </p>
                            <p className="text-sm text-gray-900">{callData.output.contact_details.name}</p>
                          </div>
                          <div className='flex items-center gap-2'>
                            <p className="text-sm text-gray-900 font-medium">Date of Birth: </p>
                            <p className="text-sm text-gray-900">{callData.output.contact_details.date_of_birth}</p>
                          </div>
                        </div>
                      )}

                      <div className="grid grid-cols-2 gap-6">
                        {callData.output?.question_output?.map((item: any) => {
                          const isTextField = ['radio','checkbox'].includes(item.type);
                          return (
                            <div key={item.question_id} className={`border border-gray-200 rounded-md p-4 ${isTextField ? 'col-span-2' : 'col-span-1'}`}>
                              <p className="text-sm font-semibold text-gray-900 mb-2">
                                {item.question ?? item.label}
                                {item.optional && <span className="text-gray-400 font-normal ml-1">(Optional)</span>}
                              </p>

                              {item.type === 'radio' && (
                                <div className="flex flex-wrap gap-4 items-center">
                                  {item.options.map((opt: string) => (
                                    <label key={opt} className="flex items-center cursor-pointer !mt-0 !mb-0">
                                      <input 
                                        type="radio" 
                                        name={item.question_id} 
                                        defaultChecked={item.answer === opt} 
                                        className="!w-4 !h-4 min-w-4 min-h-4 text-purple-600 border-gray-300 focus:ring-purple-500" 
                                      />
                                      <span className="text-sm text-gray-700">{opt}</span>
                                    </label>
                                  ))}
                                </div>
                              )}

                              {item.type === 'checkbox' && (
                                <div className="flex flex-wrap gap-4 items-center">
                                  {item.options.map((opt: string) => (
                                    <label key={opt} className="flex items-center cursor-pointer !mt-0 !mb-0">
                                      <input 
                                        type="checkbox" 
                                        defaultChecked={item.answer === opt || (Array.isArray(item.answer) && item.answer.includes(opt))} 
                                        className="!w-4 !h-4 min-w-4 min-h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500" 
                                      />
                                      <span className="text-sm text-gray-700">{opt}</span>
                                    </label>
                                  ))}
                                </div>
                              )}

                              {item.type === 'dropdown' && (
                                <div className="mt-1">
                                  <select
                                    defaultValue={item.answer || (item.options && item.options[0]) || ''}
                                    className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:border-blue-500 focus:ring-3 focus:ring-blue-500/10 transition-all"
                                  >
                                    {(item.options || []).map((opt: string) => (
                                      <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                  </select>
                                </div>
                              )}

                              {(item.type === 'text' || !['radio', 'checkbox'].includes(item.type)) && (
                                <div className="mt-1">
                                  <input 
                                    type="text" 
                                    defaultValue={item.answer} 
                                    className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:border-blue-500 focus:ring-3 focus:ring-blue-500/10 transition-all" 
                                  />
                                </div>
                              )}

                              {item.nested_questions && item.nested_questions.length > 0 && (
                                <div className="mt-3 space-y-3">
                                  {item.nested_questions.map((nested: any) => (
                                    <div key={nested.question_id}>
                                      <p className="text-xs text-gray-600 mb-1">{nested.question ?? nested.label}</p>
                                      <input 
                                        type="text" 
                                        defaultValue={nested.answer} 
                                        className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:border-blue-500 focus:ring-3 focus:ring-blue-500/10 transition-all" 
                                      />
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    
                    <div className="flex justify-end pt-4">
                      <button className="px-4 py-1.5 text-sm rounded-full transition btn-secondary !border !border-solid !border-primary">
                        Save to Record
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Header Section */}
      <div className="bg-white border-b border-gray-200 px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-purple-100 p-3 rounded-lg">
              <User className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <div className="flex items-center gap-3">
                <h1 className="text-xl font-bold text-gray-900">
                  {member.first_name} {member.last_name}
                </h1>
                <PriorityBadge priority={getRiskPriority(member.risk_score)} />
              </div>
              <p className="text-sm text-gray-600 mt-0.5">
                {member.member_id} • {member.date_of_birth ? new Date().getFullYear() - new Date(member.date_of_birth).getFullYear() : 'N/A'}yo {member.date_of_birth && member.date_of_birth.split('-')[0] > '2000' ? 'M' : 'F'} • {member.program || 'Medicaid-TX'}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2 text-gray-700">
              <Phone className="w-4 h-4" />
              <span className="text-sm">{member.phone || '(512) 555-0147'}</span>
              
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <MessageCircle className="w-4 h-4" />
              <span className="text-sm">{member.preferred_language}</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <UserCheck className="w-4 h-4" />
              <span className="text-sm">{member.assigned_care_manager || 'Dr. Sarah Mitchell'}</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <button 
                onClick={handleStartCall}
                className="px-4 py-1.5 text-sm rounded-full transition btn-secondary"
                title="Start Call"
              >
                <Phone className="w-4 h-4" />
                <span className="text-sm font-bold uppercase tracking-wider hidden lg:inline-block">Call</span>
              </button>
            </div>
          </div>

          <div className="flex items-center gap-8">
            <div className="text-right">
              <p className="text-xs text-gray-500 mb-1">Risk Score</p>
              <div className="flex items-baseline gap-1">
                <span className={`text-3xl font-bold ${getRiskScoreColor(member.risk_score || 0)}`}>
                  {(member.risk_score || 0).toFixed(1)}
                </span>
                <TrendingUp className="w-4 h-4 text-red-500" />
              </div>
            </div>
            <div className="text-right">
              <p className="text-xs text-gray-500 mb-1">Next Contact</p>
              <p className="text-base font-semibold text-purple-600">{nextContactDate}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white border-b border-gray-200 px-8">
        <nav className="flex gap-8">
          {[
            { id: 'assessment', label: 'Assessment', icon: Clipboard, badge: `${assessmentCompletion}%` },
            { id: 'careplan', label: 'Care Plan', icon: Target },
            { id: 'interventions', label: 'Interventions', icon: Zap, badge: interventions.length },
            { id: 'documentation', label: 'Documentation', icon: FileText },
          ].map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id as any)}
                className={`flex items-center gap-2 py-4 border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-purple-600 text-purple-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="font-medium text-sm">{tab.label}</span>
                {tab.badge && (
                  <span
                    className={`px-2 py-0.5 text-xs rounded-full font-medium ${
                      activeTab === tab.id
                        ? 'bg-purple-100 text-purple-700'
                        : 'bg-gray-100 text-gray-600'
                    }`}
                  >
                    {tab.badge}
                  </span>
                )}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Content Area */}
      <div className="px-8 py-6">
        <div className="grid grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="col-span-2 space-y-6">
            {/* Assessment Tab */}
            {activeTab === 'assessment' && (
              <>
                {/* Progress */}
                <Card>
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-semibold text-gray-900">Assessment Completion</h2>
                    <span className="text-2xl font-bold text-gray-900">{assessmentCompletion}%</span>
                  </div>
                  <ProgressBar value={assessmentCompletion} variant="success" size="lg" className="[&>div>div]:bg-purple-600" />
                  <p className="text-sm text-gray-600 mt-3 flex items-center gap-1">
                    <Sparkles className="w-4 h-4" />
                    AI has pre-filled {assessmentCompletion}% of fields from claims, EHR, and previous assessments
                  </p>
                </Card>

                {/* Health Status */}
                <Card>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <Clipboard className="w-5 h-5 text-green-600" />
                      <h2 className="text-lg font-semibold text-gray-900">Health Status Assessment</h2>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-gray-600">4 fields</span>
                      <ConfidenceBadge score={94} />
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div>
                      <div className="flex items-center justify-between mb-2">
                        <label className="text-sm font-medium text-gray-700">Active Chronic Conditions</label>
                        <button className="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1">
                          <span>Source: Claims + EHR</span>
                          <Edit className="w-3 h-3" />
                        </button>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        <Pill variant="primary">Type 2 Diabetes</Pill>
                        <Pill variant="primary">CHF (NYHA Class II)</Pill>
                        <Pill variant="primary">CKD Stage 3b</Pill>
                        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">+ Add</button>
                      </div>
                      <p className="text-xs text-gray-500 mt-2 flex items-center gap-1">
                        <AlertTriangle className="w-3 h-3" />
                        Extracted from recent claims (ICD-10 codes) and EHR problem list. CHF class confirmed via recent cardiology note.
                      </p>
                    </div>

                    <div>
                      <div className="flex items-center justify-between mb-2">
                        <label className="text-sm font-medium text-gray-700">Current Symptoms Reported</label>
                        <button className="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1">
                          <span>Source: EHR Clinical Notes</span>
                          <Edit className="w-3 h-3" />
                        </button>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        <Pill variant="warning">Fatigue</Pill>
                        <Pill variant="warning">Shortness of breath on exertion</Pill>
                        <Pill variant="warning">Lower extremity edema</Pill>
                        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">+ Add</button>
                      </div>
                      <p className="text-xs text-gray-500 mt-2 flex items-center gap-1">
                        <AlertTriangle className="w-3 h-3" />
                        Symptoms extracted from ED visit note dated 11/28. Member reported these during triage.
                      </p>
                    </div>
                  </div>
                </Card>
              </>
            )}

            {/* Care Plan Tab */}
            {activeTab === 'careplan' && carePlan && (
              <>
                {/* Care Plan Header */}
                <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl p-6 text-white">
                  <div className="flex items-start justify-between">
                    <div className="flex items-center gap-4">
                      <div className="bg-white/20 p-3 rounded-lg">
                        <Target className="w-8 h-8" />
                      </div>
                      <div>
                        <h2 className="text-2xl font-bold mb-1">{carePlan.plan_type}</h2>
                        <p className="text-blue-100">
                          AI-Generated Care Plan • {Math.round(carePlan.confidence_score)}% Confidence
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg font-medium transition-colors flex items-center gap-2">
                        <Edit className="w-4 h-4" />
                        Edit Plan
                      </button>
                      <button className="px-4 py-2 bg-white text-purple-600 hover:bg-purple-50 rounded-lg font-medium transition-colors flex items-center gap-2">
                        <FileCheck className="w-4 h-4" />
                        Approve & Sign
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-6 mt-6">
                    <div>
                      <p className="text-blue-100 text-sm mb-1">Effective Date</p>
                      <p className="text-lg font-semibold">{formatDate(carePlan.effective_date)}</p>
                    </div>
                    <div>
                      <p className="text-blue-100 text-sm mb-1">Review Date</p>
                      <p className="text-lg font-semibold">{formatDate(carePlan.review_date)}</p>
                    </div>
                    <div>
                      <p className="text-blue-100 text-sm mb-1">Problems Addressed</p>
                      <p className="text-lg font-semibold">{carePlan.problems_count} Active</p>
                    </div>
                  </div>
                </div>

                {/* Care Plan Goals */}
                <Card>
                  <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
                    <div className="flex items-center gap-2">
                      <span className="px-3 py-1 bg-red-100 text-red-700 text-xs font-semibold rounded">HIGH</span>
                      <h3 className="text-lg font-bold text-gray-900">Heart Failure Management (I50.9)</h3>
                    </div>
                    <Badge variant="success">active</Badge>
                  </div>

                  <div>
                    <div className="flex items-center gap-2 mb-4">
                      <Target className="w-5 h-5 text-purple-600" />
                      <h4 className="font-semibold text-gray-900">Goals</h4>
                    </div>
                    <div className="space-y-3">
                      {carePlanGoals.slice(0, 3).map((goal) => (
                        <div key={goal.id} className="flex items-start gap-3">
                          <input
                            type="checkbox"
                            checked={goal.completed}
                            className="mt-1 w-4 h-4 rounded border-gray-300"
                            readOnly
                          />
                          <div className="flex-1">
                            <p className="text-sm text-gray-900">{goal.goal_text}</p>
                          </div>
                          <TimeframePill days={goal.timeframe_days} />
                        </div>
                      ))}
                    </div>
                  </div>
                </Card>
              </>
            )}

            {/* Interventions Tab */}
            {activeTab === 'interventions' && (
              <>
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h2 className="text-lg font-semibold text-gray-900">AI-Recommended Interventions</h2>
                    <p className="text-sm text-gray-600">Review and accept or decline suggested interventions</p>
                  </div>
                  <span className="text-sm text-gray-600">{interventions.filter(i => i.status === 'pending').length} pending review</span>
                </div>

                <div className="space-y-4">
                  {interventions.map((intervention) => (
                    <Card key={intervention.id}>
                      <div className="flex items-start gap-4">
                        <div className="bg-purple-50 p-3 rounded-lg">
                          <Sparkles className="w-6 h-6 text-purple-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-start justify-between mb-2">
                            <div>
                              <div className="flex items-center gap-2 mb-1">
                                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                  {intervention.category.replace('_', ' ')}
                                </span>
                                <EffortBadge level={intervention.effort_level} />
                                <ConfidenceBadge score={Math.round(intervention.confidence_score)} />
                              </div>
                              <h3 className="text-base font-semibold text-gray-900">{intervention.title}</h3>
                            </div>
                          </div>
                          <p className="text-sm text-gray-700 mb-3">{intervention.description}</p>
                          <div className="flex items-center gap-4 text-xs text-gray-600 mb-3">
                            <div className="flex items-center gap-1">
                              <TrendingUp className="w-3 h-3" />
                              <span>Impact: {intervention.impact_description}</span>
                            </div>
                            <div className="flex items-center gap-1">
                              <FileText className="w-3 h-3" />
                              <span>{intervention.evidence_citation}</span>
                            </div>
                          </div>
                          <div className="flex gap-2">
                            <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center gap-2 text-sm font-medium">
                              <ThumbsUp className="w-4 h-4" />
                              Accept
                            </button>
                            <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-2 text-sm font-medium">
                              <ThumbsDown className="w-4 h-4" />
                              Decline
                            </button>
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>

                {/* Intervention Summary */}
                <Card className="bg-gray-50">
                  <h3 className="font-semibold text-gray-900 mb-4">Intervention Summary</h3>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Accepted</p>
                      <p className="text-3xl font-bold text-green-600">0</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Declined</p>
                      <p className="text-3xl font-bold text-gray-600">0</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Pending</p>
                      <p className="text-3xl font-bold text-amber-600">{interventions.length}</p>
                    </div>
                  </div>

                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <div className="flex items-start gap-2">
                      <Sparkles className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" />
                      <div>
                        <h4 className="font-semibold text-gray-900 text-sm mb-1">How AI Selects Interventions</h4>
                        <ul className="text-xs text-gray-600 space-y-1">
                          <li className="flex items-center gap-2">
                            <CheckCircle className="w-3 h-3 text-purple-600" />
                            Analyzes member's specific conditions and risk factors
                          </li>
                          <li className="flex items-center gap-2">
                            <CheckCircle className="w-3 h-3 text-purple-600" />
                            Matches interventions to evidence-based guidelines
                          </li>
                          <li className="flex items-center gap-2">
                            <CheckCircle className="w-3 h-3 text-purple-600" />
                            Considers SDOH barriers and practical feasibility
                          </li>
                          <li className="flex items-center gap-2">
                            <CheckCircle className="w-3 h-3 text-purple-600" />
                            Ranks by expected impact and effort required
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card>
              </>
            )}

            {/* Documentation Tab */}
            {activeTab === 'documentation' && (
              <>
                <div className="mb-6">
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">Generate Documentation</h2>
                  <p className="text-sm text-gray-600">Choose a documentation template above to auto-generate clinical notes</p>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-8">
                  {[
                    { icon: Clipboard, title: 'Initial Assessment Note', category: 'Assessment' },
                    { icon: Target, title: 'Care Plan Update', category: 'Care Plan' },
                    { icon: Phone, title: 'Telephonic Encounter', category: 'Progress Note' },
                    { icon: Users, title: 'Care Coordination Note', category: 'Coordination' },
                  ].map((template) => {
                    const Icon = template.icon;
                    return (
                      <button
                        key={template.title}
                        className="p-4 bg-white border-2 border-gray-200 rounded-xl hover:border-purple-400 hover:bg-purple-50 transition-all text-left group"
                      >
                        <div className="flex items-center gap-3 mb-2">
                          <div className="bg-purple-100 p-2 rounded-lg group-hover:bg-purple-200 transition-colors">
                            <Icon className="w-5 h-5 text-purple-600" />
                          </div>
                          <Sparkles className="w-4 h-4 text-amber-500" />
                        </div>
                        <h3 className="font-semibold text-gray-900 mb-1">{template.title}</h3>
                        <p className="text-sm text-gray-600">{template.category}</p>
                      </button>
                    );
                  })}
                </div>

                <div className="border-2 border-dashed border-gray-300 rounded-xl p-12 text-center">
                  <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Select a Template</h3>
                  <p className="text-sm text-gray-600">Choose a documentation template above to auto-generate clinical notes</p>
                </div>

                <div className="grid grid-cols-2 gap-6 mt-6">
                  <Card className="bg-green-50 border-green-200">
                    <div className="flex items-start gap-3">
                      <Clock className="w-5 h-5 text-green-600" />
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-1">Documentation Time Saved</h4>
                        <p className="text-3xl font-bold text-green-600">~25 min</p>
                        <p className="text-xs text-gray-600 mt-2">AI auto-generated note from assessment data, care plan, and member information</p>
                      </div>
                    </div>
                  </Card>

                  <Card>
                    <div className="flex items-start gap-3">
                      <Shield className="w-5 h-5 text-purple-600" />
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">Compliance Check</h4>
                        <div className="space-y-1 text-sm">
                          <div className="flex items-center gap-2 text-green-700">
                            <CheckCircle className="w-4 h-4" />
                            <span>NCQA CM Standards</span>
                          </div>
                          <div className="flex items-center gap-2 text-green-700">
                            <CheckCircle className="w-4 h-4" />
                            <span>State Medicaid Requirements</span>
                          </div>
                          <div className="flex items-center gap-2 text-green-700">
                            <CheckCircle className="w-4 h-4" />
                            <span>HIPAA Compliant</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>

                <Card className="bg-purple-50 border-purple-200">
                  <div className="flex items-center gap-2 mb-2">
                    <CheckCircle className="w-5 h-5 text-purple-600" />
                    <h4 className="font-semibold text-gray-900">Documentation Checklist</h4>
                  </div>
                  <div className="space-y-2 text-sm">
                    {[
                      'Initial Assessment',
                      'Care Plan Created',
                      'Goals Documented',
                      'Interventions Assigned',
                      'Next Contact Scheduled',
                    ].map((item) => (
                      <div key={item} className="flex items-center gap-2 text-green-700">
                        <CheckCircle className="w-4 h-4" />
                        <span>{item}</span>
                      </div>
                    ))}
                    <div className="flex items-center gap-2 text-gray-400">
                      <div className="w-4 h-4 border-2 border-gray-300 rounded" />
                      <span>Supervisor Review</span>
                    </div>
                  </div>
                </Card>
              </>
            )}
          </div>

          {/* Right Sidebar */}
          <div className="space-y-6">
            {/* AI Assistant Panel - Only show on Assessment tab */}
            {activeTab === 'assessment' && (
              <Card className="bg-gradient-to-br from-purple-600 to-purple-700 text-white">
                <div className="flex items-center gap-2 mb-3">
                  <Sparkles className="w-5 h-5" />
                  <h3 className="font-semibold">AI Assessment Assistant</h3>
                </div>
                <p className="text-sm text-purple-100 mb-4">
                  I've analyzed claims, EHR data, and previous assessments to pre-fill this form. Review and validate each section.
                </p>

                <div className="space-y-3">
                  <div>
                    <p className="text-sm font-semibold mb-2">Key Findings:</p>
                    <div className="space-y-2">
                      {aiInsights.map((insight) => (
                        <div key={insight.id} className="flex items-start gap-2 text-sm">
                          {insight.severity === 'critical' ? (
                            <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
                          ) : insight.severity === 'warning' ? (
                            <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
                          ) : (
                            <CheckCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />
                          )}
                          <span className="text-purple-50">{insight.title}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Card>
            )}

            {/* Care Team - Only show on Care Plan tab */}
            {activeTab === 'careplan' && (
              <Card>
                <div className="flex items-center gap-2 mb-4">
                  <Users className="w-5 h-5 text-purple-600" />
                  <h3 className="font-semibold text-gray-900">Care Team</h3>
                </div>
                <div className="space-y-3">
                  {careTeam.map((member) => (
                    <div key={member.id} className="flex items-start gap-3">
                      <div className="bg-purple-100 p-2 rounded-lg">
                        <User className="w-4 h-4 text-purple-600" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="font-medium text-gray-900 text-sm">{member.name}</p>
                        <p className="text-xs text-purple-600 font-medium">{member.role}</p>
                        <p className="text-xs text-gray-600 mt-1">{member.responsibilities}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            )}

            {/* Data Sources */}
            <Card>
              <h3 className="font-semibold text-gray-900 mb-4">Data Sources Used</h3>
              <div className="space-y-3">
                {dataSources.map((source) => (
                  <div key={source.source_name} className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full" />
                      <span className="text-sm text-gray-700">{source.source_name}</span>
                    </div>
                    <span className="text-sm font-medium text-gray-900">
                      {source.record_count.toLocaleString()} records
                    </span>
                  </div>
                ))}
              </div>
            </Card>

            {/* Scheduled Contacts - Only show on Care Plan tab */}
            {activeTab === 'careplan' && (
              <Card>
                <div className="flex items-center gap-2 mb-4">
                  <Calendar className="w-5 h-5 text-purple-600" />
                  <h3 className="font-semibold text-gray-900">Scheduled Contacts</h3>
                </div>
                <div className="space-y-3">
                  <div className="p-3 bg-purple-50 rounded-lg">
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-sm font-medium text-gray-900">Follow-up Call</span>
                      <span className="text-xs text-purple-600">Tomorrow</span>
                    </div>
                    <p className="text-xs text-gray-600">Review medication adherence and CHF symptoms</p>
                  </div>
                </div>
              </Card>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
